import { createServerFn } from "@tanstack/solid-start";
import { z } from "zod";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const GetPnLInputSchema = z.object({
  businessId: z.string().trim().min(1),
  from: z.string().trim().min(1).optional(),
  to: z.string().trim().min(1).optional(),
  classIds: z.array(z.string().trim().min(1)).optional(),
});

export const getPnL = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => GetPnLInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("reports.pnl", async () => {
      const { getPnLForUser } = await import("./p-and-l.server");
      return getPnLForUser(context.user.id, data.businessId, {
        from: data.from,
        to: data.to,
        classIds: data.classIds,
      });
    });
  });
